import { form } from 'formifier';

const errorMessages = {
  firstName: {
    valueMissing: 'Please enter your first name.',
    tooLong: 'Please enter 40 characters or less for your first name.'
  },
  lastName: {
    valueMissing: 'Please enter your last name.',
    tooLong: 'Please enter 80 characters or less for your last name.'
  },
  email: {
    valueMissing: 'Please enter your email address.',
    patternMismatch: 'Please enter a valid email address.',
    tooLong: 'Please enter 80 characters or less for your email address.'
  },
  phone: {
    valueMissing: 'Please enter your phone number.',
    patternMismatch: 'Please enter a valid phone number.',
    tooLong: 'Please enter 17 characters or less for the phone number.'
  },
  city: {
    valueMissing: 'Please enter your city.',
    tooLong: 'Please enter 40 characters or less for the price.'
  },
  address: {
    valueMissing: 'Please enter your street address.',
    patternMismatch: 'Please enter a valid street address.',
    tooLong: 'Please enter 64 characters or less for your street address.'
  },
  address2: {
    valueMissing: 'Please enter your street address.',
    patternMismatch: 'Please enter a valid street address.',
    tooLong: 'Please enter 64 characters or less for your street address.'
  },
  zipCode: {
    valueMissing: 'Please enter your ZIP code.',
    patternMismatch: 'Please enter a valid ZIP code.',
    tooLong: 'Please enter 10 characters or less for your ZIP code.'
  },
  question: {
    valueMissing: 'Please enter a question.',
    tooLong: 'Please enter 1000 characters or less for your question.'
  }
};

form(errorMessages, document.getElementById('ask-personalities-form'));
